export const API_RETRY_DELAY_MS = 5000

export const isApiUnavailableError = (error: unknown): boolean => {
    const status = (error as {status?: number} | undefined)?.status
    return !status || status >= 500
}

const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms))

export const retryWhileApiUnavailable = async <T>(
    fn: () => Promise<T>,
    isCancelled: () => boolean = () => false,
): Promise<T> => {
    while (true) {
        try {
            return await fn()
        } catch (error) {
            if (!isApiUnavailableError(error) || isCancelled()) {
                throw error
            }
            await wait(API_RETRY_DELAY_MS)
        }
    }
}
